// Vendor menu items switch pages inside VendorModule through window events.
// Pages like /vendorWorkOrderAU are separate routes where nobody listens for
// those events, so from there we go to VendorModule and let it pick up the
// page (or the Download Centre) from sessionStorage when it mounts.

const isOnVendorModule = () =>
    window.location.hash.split('?')[0].toLowerCase() === '#/vendormodule';

export const goToVendorPage = (navigate, page) => {
    sessionStorage.setItem("summaryPage", page);
    if (isOnVendorModule()) {
        window.dispatchEvent(new CustomEvent('vendorNavigate', { detail: page }));
    } else {
        navigate('/VendorModule');
    }
};

export const openVendorDownloadCentre = (navigate) => {
    if (isOnVendorModule()) {
        window.dispatchEvent(new CustomEvent('vendorOpenDownloadCentre'));
    } else {
        sessionStorage.setItem("openDownloadCentre", "true");
        navigate('/VendorModule');
    }
};
